import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import Layout from "../components/Layout";
import Seo from "../seo/Seo";

const NotFound = () => (
  <Layout>
    <Seo
      title="Stránka sa nenášla (404) | Ján Kuráň Ružomberok"
      description="Požadovaná stránka neexistuje."
      path="/404"
    />
    <section className="bg-campaign-cream px-4 py-24 sm:py-32 text-center">
      <div className="max-w-xl mx-auto">
        <p className="font-display text-7xl sm:text-9xl text-campaign-coral">404</p>
        <h1 className="font-display text-2xl sm:text-4xl text-campaign-ink uppercase mt-4">
          Stránka sa nenášla
        </h1>
        <p className="mt-4 text-campaign-ink/80">
          Je možné, že odkaz je nesprávny alebo stránka bola presunutá.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-campaign-blue text-campaign-cream font-display uppercase text-sm px-6 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
        >
          <HomeIcon size={18} /> Späť na hlavnú stránku
        </Link>
      </div>
    </section>
  </Layout>
);

export default NotFound;
